/**
 * A2UI List Component
 * Renders a list of children, supporting both explicit lists and templates
 */

import React from 'react';

const A2UIList = ({ 
  children,
  direction = 'vertical',
  gap = 8,
  style,
  renderChildren,
  surfaceId
}) => {
  const isVertical = direction === 'vertical';
  
  const listStyle = {
    display: 'flex',
    flexDirection: isVertical ? 'column' : 'row',
    gap: `${gap}px`,
    listStyle: 'none',
    padding: 0,
    margin: 0,
    ...style
  };

  return (
    <ul className="a2ui-list" style={listStyle}>
      {renderChildren ? renderChildren(children, true) : null}
    </ul>
  );
};

export default A2UIList;
